import * as React from 'react';
import PropTypes from 'prop-types';

/**
 * SlideText
 */

const SlideText = ({ text, layout, tag }) => {
  const Tag = tag || 'div';
  const elementClass = layout || '';
  return <Tag dangerouslySetInnerHTML={{ __html: text }} className={`slide-text ${elementClass}`} />;
};

SlideText.propTypes = {
  text: PropTypes.string.isRequired,
  layout: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  tag: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

export default SlideText;
